import { __rest } from "tslib";
import React, { useMemo, useRef } from 'react';
import ScrollLock from 'react-scrolllock';
import { useModalCloseEvents } from './ModalOverlay.hooks.js';
import { ModalWrapper, Overlay } from './ModalOverlay.styled.js';
import { InternalModalContext } from '../context.js';
export const ModalOverlay = (_a) => {
    var { children, className, onClose, closeOnEsc, closeOnOutsideClick, wrapperPadding } = _a, rest = __rest(_a, ["children", "className", "onClose", "closeOnEsc", "closeOnOutsideClick", "wrapperPadding"]);
    const modalRef = useRef(null);
    const overlayRef = useRef(null);
    const internalContext = useMemo(() => ({ onClose }), [onClose]);
    const { onOverlayClick } = useModalCloseEvents(onClose, closeOnEsc, closeOnOutsideClick, modalRef, overlayRef);
    return (React.createElement(InternalModalContext.Provider, { value: internalContext },
        React.createElement(Overlay, Object.assign({}, rest, { className: className, ref: overlayRef, onClick: onOverlayClick }),
            React.createElement(ModalWrapper, { ref: modalRef, wrapperPadding: wrapperPadding },
                React.createElement(ScrollLock, null),
                children))));
};
//# sourceMappingURL=ModalOverlay.js.map